import {
    Component,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {NouisliderComponent} from 'ng2-nouislider';
import {Constants} from '../../../shared/config/constants.config';
import {InfluencerViewModel} from '../../../shared/viewModels/stars.viewModel';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Languages} from '../../../shared/enums/languages';
import {LocalisationService} from '../../../shared/services/localisation.service';
import {PricingService} from '../../../pricing/services/pricing.service';
import {BraintreeBgTranslationConfig} from '../../../shared/config/braintree.bg.translation.config';
import {StarsSingleComponent} from '../stars-single/stars-single.component';

@Component({
    selector: 'app-add-addon-modal',
    templateUrl: './add-addon.component.html',
    styleUrls: ['./add-addon.component.scss']
})
export class AddAddonComponentModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    @ViewChild('slider') slider: NouisliderComponent;

    influencer: InfluencerViewModel;
    starsSingle: StarsSingleComponent;
    braintreeInstance;
    showPayButton = false;

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly localisationService: LocalisationService,
        private readonly pricingService: PricingService,
        private readonly braintreeBgTranslationConfig: BraintreeBgTranslationConfig,
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {

    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }

        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        const interval = setInterval(() => {
            if (this.influencer) {
                clearInterval(interval);

                this.load();
            }
        });
    }

    load() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.pricingService.braintreeGenerateClientToken().subscribe(clientToken => {
            const params = {
                authorization: clientToken.client_token,
                container: '#dropin-container',
                paypal: {flow: 'vault'}
            };

            if (this.localisationService.getLanguage() === Languages.Bulgarian) {
                params['translations'] = this.braintreeBgTranslationConfig.translations;
            }

            // @ts-ignore
            braintree.dropin.create(params, (createErr, instance) => {
                this.braintreeInstance = instance;
                this.showPayButton = true;

                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            });
        });
    }

    onClose() {
        this.bsModalRef.hide();
    }


    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    requestPaymentMethod() {
        this.braintreeInstance.requestPaymentMethod((requestPaymentMethodErr, payload) => {
            if (typeof payload !== 'undefined') {
                this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

                this.pricingService.createSubscriptionAddonTransaction({
                    client_nonce: payload.nonce,
                    influencer_id: this.influencer.influencer.id
                })
                    .subscribe(() => {
                        this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                        this.bsModalRef.hide();
                        this.starsSingle.influencerInSubscription = true;
                        this.starsSingle.changeDetectorRef.markForCheck();
                    }, () => {
                        alert(this.localisationService.localise('transaction_failed'));
                        window.location.reload();
                    });
            }
        });
    }
}
